import { api } from '../axiosInstance';
import { ConversationDto } from '@/entities/conversation/conversation.dto';
import { ConversationEntity } from '@/entities/conversation/conversation.entity';
import { mapConversationDataDtoToEntity } from '@/entities/conversation/conversation.mapper';

export const conversationService = {
  getConversation: async (
    childId: string | number,
    page: number = 1,
  ): Promise<ConversationEntity> => {
    const response = await api.get<ConversationDto>(
      `students/${childId}/support/conversation?page=${page}`,
    );
    return mapConversationDataDtoToEntity(response.data.data, childId);
  },

  sendMessage: async (childId: string | number, data: any): Promise<any> => {
    const response = await api.post(`students/${childId}/support/conversation`, data);
    return response.data;
  },

  markAsSeen: async (childId: string | number, conversationId: string | number): Promise<any> => {
    const response = await api.post(
      `https://api.classquiz.tn/v2/students/${childId}/support/conversation/${conversationId}/mark-seen`,
    );
    return response.data;
  },
};
